module.exports = __webpack_public_path__ + "static/media/data.65273c17.png";